import { Card, CardContent } from '../../../../components/ui/card'
import { Progress } from '../../../../components/ui/progress'
import type { PillarData } from '../../types'
import { PILLAR_META, PILLAR_ORDER } from '../../types'

interface PillarBreakdownProps {
  pillars: Record<string, PillarData>
}

export default function PillarBreakdown({ pillars }: PillarBreakdownProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-gray-900">Pillar Scores</h3>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {PILLAR_ORDER.map((key) => {
          const p = pillars[key]
          const meta = PILLAR_META[key]
          if (!p || !meta) return null

          return (
            <Card key={key} className="overflow-hidden">
              <CardContent className="p-4 space-y-2">
                <div className="flex items-center gap-2">
                  <i className={`${meta.icon} text-lg`} style={{ color: meta.color }} />
                  <div className="flex flex-col">
                    <span className="text-xs font-semibold text-gray-700">{key}</span>
                    <span className="text-[10px] text-gray-500 leading-tight">{meta.label}</span>
                  </div>
                </div>
                <p className="text-2xl font-bold" style={{ color: meta.color }}>
                  {typeof p.score === 'number' ? p.score.toFixed(1) : '—'}
                </p>
                <Progress
                  value={typeof p.score === 'number' ? p.score : 0}
                  className="h-1.5"
                  style={{ ['--tw-progress-color' as any]: meta.color }}
                />
                <p className="text-xs text-gray-500">{(p.weight * 100).toFixed(0)}% weight</p>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </div>
  )
}
